// eslint-disable-next-line import/prefer-default-export
export function validateIllegalCharachters(value: string, illegalCharacters: string[]): boolean {
  if (value && illegalCharacters && illegalCharacters.length > 0) {
    // eslint-disable-next-line arrow-body-style
    const containsIllegalCharacters: boolean = illegalCharacters.some((illegalCharacter: string) => {
      return value.indexOf(illegalCharacter) >= 0;
    });

    return !containsIllegalCharacters;
  }

  return true;
}
